import { IAddressWidgetConfig, AddressWidgetConfig } from '../types/index';
import { ThrowReporter } from 'io-ts/lib/ThrowReporter';

function decodeAddressConfig(config: string, onError: 'THROW_ERROR'): IAddressWidgetConfig;
function decodeAddressConfig(config: string, onError: 'RETURN_NULL'): IAddressWidgetConfig | null;
function decodeAddressConfig(config: string, onError: 'THROW_ERROR' | 'RETURN_NULL') {
    try {
        const parsedConfig: IAddressWidgetConfig = JSON.parse(config);
        const decodeResult = AddressWidgetConfig.decode(parsedConfig);
        ThrowReporter.report(decodeResult); // throws error if decode fails. Should always be right, but refine anyway
        if (decodeResult.isRight()) {
            return decodeResult.value;
        }
        return null;
    } catch (e) {
        if (onError === 'THROW_ERROR') {
            throw e;
        } else {
            return null;
        }
    }
}
export default decodeAddressConfig;
